import { isTemplateExport } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";
import {
  OtherBlock,
  TemplateBlock,
} from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import type { BlockExportMapping } from "../../BuilderUI.types";
import type { BlockCategory } from "../../DataModel.types";

export const processBlockCategories = ({
  blocks,
  excludeCategories = [],
}: {
  blocks: BlockExportMapping;
  excludeCategories?: string[];
}): Map<string, BlockCategory> => {
  const categoriesMap = new Map<string, BlockCategory>();

  for (const block of Object.values(blocks)) {
    const meta = block.meta;

    if (meta.isHidden === true) {
      continue;
    }

    if (isTemplateExport(block)) {
      categoriesMap.set(TemplateBlock.name, TemplateBlock);
      continue;
    }

    const categories = meta.category?.length ? meta.category : [OtherBlock];

    for (const category of categories) {
      const key = category.nameI18n || category.name;
      if (
        !excludeCategories.includes(category.name) &&
        !categoriesMap.has(key)
      ) {
        categoriesMap.set(key, category);
      }
    }
  }

  return categoriesMap;
};
